import { TertiaryButton } from '@dev/ee-components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useIntercom } from 'react-use-intercom';
import { isCustomBranding } from '@api/services/Security';
import { getAccountStore } from '@api/store/account/actions';

export const CustommerSupportButton: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const { GeneralInfo, AdvancedOptions } = useSelector(getAccountStore);
    const { show, boot } = useIntercom() || {};

    const isReseller = isCustomBranding() || AdvancedOptions?.IsOwnedByReseller;

    const showIntercom = () => {
        !isReseller && boot();
        !isReseller && show();
    };

    if (isReseller) {
        const supportLink = GeneralInfo?.SupportLink || '';
        const haveProtocol = supportLink?.startsWith?.('http');
        return supportLink ? (
            <a href={`${haveProtocol ? '' : '//'}${GeneralInfo?.SupportLink}`} target="_blank" rel="noreferrer">
                {t('customersupport')}
            </a>
        ) : (
            <span>{t('customersupport')}</span>
        );
    }
    return <TertiaryButton text={t('customersupport')} onClick={showIntercom} size="small" />;
};
